import styled from 'styled-components';
import MuiIconButton from '@material-ui/core/IconButton';

// TODO:implement not only primary and secondary but also error or something close to it
export const IconButton = styled(MuiIconButton).attrs(() => ({}))``;
